import isEmpty from 'lodash/isEmpty';

import { updateItem } from 'common/api/winds';
import showToast from 'common/utils/showToast';

import { SAVE, SAVE_SUCCESS, SAVE_FAILURE } from '../actionTypes';
import { actions } from '../reducer';

import closeModalProduct from './closeModalProduct';
import fetchItems from './fetchItems';

export default (filterData, values, id) => (dispatch) => {
    dispatch(actions[SAVE]());

    updateItem(values, id)
        .then((response) => {
            dispatch(actions[SAVE_SUCCESS](response.data));
            if (!isEmpty(filterData)) dispatch(fetchItems(filterData));
            dispatch(closeModalProduct());
            showToast();
        })
        .catch((error) =>
            dispatch(actions[SAVE_FAILURE](error?.response?.data?.errors)),
        );
};
